/**
 * SENTRY-FIX-003: Resource Loading with Fallback CDN
 * Resolves: SYRS-SHOPIFY-J, SYRS-SHOPIFY-Q (TypeError: Load failed)
 */

(function() {
  'use strict';

  const CDN_FALLBACKS = {
    'jquery': [
      'https://code.jquery.com/jquery-3.7.1.min.js',
      'https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js',
      'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js'
    ]
  };

  window.loadResourceWithFallback = function(primaryUrl, fallbackUrls, resourceType) {
    resourceType = resourceType || 'script';
    fallbackUrls = fallbackUrls || [];

    return new Promise(function(resolve, reject) {
      let attemptCount = 0;
      const allUrls = [primaryUrl].concat(fallbackUrls);

      function attemptLoad(url) {
        attemptCount++;
        console.log('[SENTRY-FIX-003] Loading resource (attempt ' + attemptCount + '): ' + url);

        if (resourceType === 'script') {
          const script = document.createElement('script');
          
          script.onload = function() {
            console.log('[SENTRY-FIX-003] Successfully loaded: ' + url);
            resolve({ url: url, attempt: attemptCount });
          };
          
          script.onerror = function(error) {
            console.warn('[SENTRY-FIX-003] Failed to load: ' + url);
            
            if (attemptCount < allUrls.length) {
              attemptLoad(allUrls[attemptCount]);
            } else {
              console.error('[SENTRY-FIX-003] All attempts failed for resource');
              
              if (window.Sentry && window.Sentry.captureException) {
                window.Sentry.captureException(new Error('Resource loading failed: ' + primaryUrl), {
                  tags: {
                    primaryUrl: primaryUrl,
                    totalAttempts: attemptCount,
                    fix: 'SENTRY-FIX-003'
                  }
                });
              }
              
              reject(new Error('Failed to load resource after ' + attemptCount + ' attempts'));
            }
          };
          
          script.src = url;
          script.crossOrigin = 'anonymous';
          document.head.appendChild(script);
          
        } else if (resourceType === 'link') {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          
          link.onload = function() {
            console.log('[SENTRY-FIX-003] Successfully loaded stylesheet: ' + url);
            resolve({ url: url, attempt: attemptCount });
          };
          
          link.onerror = function() {
            console.warn('[SENTRY-FIX-003] Failed to load stylesheet: ' + url);
            
            if (attemptCount < allUrls.length) {
              attemptLoad(allUrls[attemptCount]);
            } else {
              reject(new Error('Failed to load stylesheet after ' + attemptCount + ' attempts'));
            }
          };
          
          link.href = url;
          link.crossOrigin = 'anonymous';
          document.head.appendChild(link);
        }
      }

      attemptLoad(allUrls[0]);
    });
  };

  window.addEventListener('error', function(event) {
    if (event.target && (event.target.tagName === 'SCRIPT' || event.target.tagName === 'LINK')) {
      const failedUrl = event.target.src || event.target.href;
      console.error('[SENTRY-FIX-003] Resource load error detected:', failedUrl);
      
      if (window.Sentry && window.Sentry.captureException) {
        window.Sentry.captureException(new Error('Resource load error: ' + failedUrl), {
          tags: {
            resourceType: event.target.tagName,
            url: failedUrl,
            fix: 'SENTRY-FIX-003'
          }
        });
      }
    }
  }, true);

  console.log('[SENTRY-FIX-003] Resource loader with fallback initialized');
})();
